import { toast } from 'react-toastify';

export const showToastOnce = (message) => {
  // toast.isActive를 사용하여 현재 활성화된 toast 확인
  if (!toast.isActive(message)) {
    toast(message, {
      toastId: message, // 메시지를 ID로 사용
      position: "top-right",
      autoClose: 3000,
    });
  }
};

let groups = [];

export const isAdmin = () => {
  return groups.some(group => group.group_name === 'admin');
};


export const saveGroups = (array) => {
  groups = array;
};

export const getGroups = () => {
  return groups;
};

// 로컬 Date → "YYYY-MM-DD" (input[type=date] value용, toISOString 대신 사용)
export const formatLocalDate = (date) => {
  const d = new Date(date);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// "YYYY-MM-DD" → 로컬 자정 Date (new Date(string)은 UTC로 파싱되므로 대신 사용)
export const parseLocalDate = (dateStr) => {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
};

// 로컬 Date → "YYYY-MM-DDTHH:MM:SS.000" (Z 없음, API 쿼리용)
// DB에 KST로 저장되므로 toISOString()(UTC) 대신 로컬 시간 문자열로 쿼리해야 함
export const formatLocalDateTime = (date) => {
  const d = new Date(date);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.000`;
};

// hex 색상을 흰색과 혼합하여 밝은 tint 생성 (투명도 없이)
// ratio: 0 = 흰색, 1 = 원색 (기본 0.15)
export const lightenColor = (hexColor, ratio = 0.25) => {
  if (!hexColor) return '#f5f5f5';
  const fullHex = hexColor.length === 4
    ? '#' + hexColor[1] + hexColor[1] + hexColor[2] + hexColor[2] + hexColor[3] + hexColor[3]
    : hexColor;
  const r = parseInt(fullHex.substr(1, 2), 16);
  const g = parseInt(fullHex.substr(3, 2), 16);
  const b = parseInt(fullHex.substr(5, 2), 16);
  const lr = Math.round(r * ratio + 255 * (1 - ratio));
  const lg = Math.round(g * ratio + 255 * (1 - ratio));
  const lb = Math.round(b * ratio + 255 * (1 - ratio));
  return `#${lr.toString(16).padStart(2, '0')}${lg.toString(16).padStart(2, '0')}${lb.toString(16).padStart(2, '0')}`;
};

export const getContrastColor = (hexColor) => {
  if (!hexColor) return 'black';
  // Handle short hex code (e.g., #03F)
  const fullHex = hexColor.length === 4
    ? '#' + hexColor[1] + hexColor[1] + hexColor[2] + hexColor[2] + hexColor[3] + hexColor[3]
    : hexColor;

  const r = parseInt(fullHex.substr(1, 2), 16);
  const g = parseInt(fullHex.substr(3, 2), 16);
  const b = parseInt(fullHex.substr(5, 2), 16);
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return (yiq >= 128) ? 'black' : 'white';
};